module.exports = __webpack_public_path__ + "img/Flag_of_Kiribati.64cf951c.svg";